

<img *ngIf="sendingChannel==sendingChannelPortal" src="./assets/img/portal_message.png" [width]="size" />
<img *ngIf="sendingChannel==sendingChannelSms" src="./assets/img/sms_message.png" [width]="size" />
<img *ngIf="sendingChannel==sendingChannelEmail" src="./assets/img/email_message.png" [width]="size" />
